  // Define menu items for the navbar
  const menuItems = [
    // { name: "Inicio", href: "/" },
    // { name: "Acerca", href: "/about" },
    { name: "Clientes", href: "/clientes" },
    { name: "Tipos de Pedido", href: "/tipo-pedidos" },
    { name: "Familias de Producto", href: "/familia-productos" },
    { name: "Bodegas", href: "/bodegas" },
    { name: "Marcas", href: "/marcas" },
    { name: "Tipos de Producto", href: "/tipo-productos" },
  ];

  export default menuItems;